import { addFilter, hasFilter, applyFilters } from '@wordpress/hooks'
import apiFetch from '@wordpress/api-fetch';
import { PanelBody, ColorPicker, PanelRow, TextControl, ToggleControl, Button, Spinner } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { useSelect, dispatch } from '@wordpress/data'
import WPEditor from '../fields/WPEditor';
import { useEffect, useState } from '@wordpress/element';

/**
 * Adding Invoice Email Templates.
 */
addFilter('wp_travel_tab_content_after_email', 'wp-travel', (content) => {
    return [...content, <InvoiceEmailTemplates />]
}, 20)

/**
 * Invoice Settings.
 */
addFilter('wp_travel_settings_tab_invoice_fields', 'wp-travel', (content) => {
    // content.splice(0, 1) // Removes the Invoice Notice (Notice must be in index 0)
    return [...content, <Invoicev4Settings />]
}, 20)

const InvoiceEmailTemplates = () => {

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const { updateSettings } = dispatch('WPTravel/Admin');

    const {
        invoice_client_template
    } = allData;

    const updateEmailData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }

    return (
        <>
            <PanelBody title={_wp_travel.setting_strings.email_tempaltes.invoice_email_templates} initialOpen={false} >
                <h3>{_wp_travel.setting_strings.email_tempaltes.client_email_template_options}</h3>

                {/** Client Email Part Starts */}
                <PanelRow>
                    <label>{_wp_travel.setting_strings.email_tempaltes.invoice_email_subject}</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={'undefined' != typeof invoice_client_template && 'undefined' != typeof invoice_client_template.client_subject ? invoice_client_template.client_subject : ''}
                            onChange={
                                (value) => { updateEmailData('invoice_client_template', 'client_subject', value) }
                            }
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{_wp_travel.setting_strings.email_tempaltes.invoice_email_title}</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={'undefined' != typeof invoice_client_template && 'undefined' != typeof invoice_client_template.client_title ? invoice_client_template.client_title : ''}
                            onChange={
                                (value) => { updateEmailData('invoice_client_template', 'client_title', value) }
                            }
                        />
                    </div>
                </PanelRow>
                <PanelRow>
                    <label>Invoice Email Header Color</label>
                    <div className="wp-travel-field-value">
                        <ColorPicker
                            color={invoice_client_template.client_header_color}
                            onChangeComplete={(value) => { updateEmailData('invoice_client_template', 'client_header_color', value.hex) }}
                            disableAlpha
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{_wp_travel.setting_strings.email_tempaltes.email_content}</label>
                </PanelRow>
                <PanelRow className="wp-travel-editor">
                    {'undefined' !== typeof invoice_client_template && 'undefined' !== typeof invoice_client_template.email_content && <WPEditor id="invoice_client_template" value={invoice_client_template.email_content}
                        onContentChange={(value) => {
                            updateEmailData('invoice_client_template', 'email_content', value)
                        }} />}
                </PanelRow>
                {/** Client Email Part Ends */}

            </PanelBody>
        </>
    )
}

const Invoicev4Settings = () => {

    const [{ imageUrl, isFetchingImage }, setState] = useState({
        imageUrl: null,
        isFetchingImage: false
    })

    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const { updateSettings } = dispatch('WPTravel/Admin');

    const {
        enable_invoice,
        invoice_address,
        invoice_contact,
        invoice_logo,
        invoice_website,
        use_relative_path,
        options,
        modules
    } = allData;

    const { default_settings } = options;
    const { modules: defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys(modules).length > 0 ? modules : defaultModules;

    const logoId = invoice_logo

    const mediaInstance = wp.media({
        multiple: false
    })

    useEffect(() => {
        if (logoId && !imageUrl) {
            setState(state => ({
                ...state,
                isFetchingImage: true
            }))
            logoId && apiFetch({ path: `/wp/v2/media/${logoId}` })
                .then((res) => {
                    setState({
                        imageUrl: res.source_url,
                        isFetchingImage: false
                    })
                })
        }
    }, [logoId])

    mediaInstance
        .on('select', () => {
            const selectedItems = mediaInstance.state().get('selection').toJSON()
            if (selectedItems.length > 0) {
                let invoiceLogoID = selectedItems[0].id
                setState({
                    imageUrl: null,
                    isFetchingImage: true
                })
                updateSettings({
                    ...allData,
                    invoice_logo: invoiceLogoID.toString()
                })
            }
        })
    const isActive = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_invoice && 'yes' === moduleSettings.show_wp_travel_invoice.value;
    if (!isActive) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return (
        <>
            {/* <PanelRow>
                <label>{ __( 'Enable Invoice', 'wp-travel-pro' ) }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ enable_invoice == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                enable_invoice: 'yes' == enable_invoice ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{__( 'This will enable trips invoice in the email.', 'wp-travel-pro' )}</p>
                </div>
            </PanelRow> */}
            {/* {enable_invoice == 'yes' &&<> */}
            <PanelRow>
                <label>
                    {_wp_travel.setting_strings.invoice.use_relative_path}
                    {hasFilter('wp_travel_settings_tab_invoice_fields_tooltip', 'wp_travel') &&
                        applyFilters('wp_travel_settings_tab_invoice_fields_tooltip', [])
                    }
                </label>
                <div id="wp-travel-invoice-use-relative-path" className="wp-travel-field-value">
                    <ToggleControl
                        checked={use_relative_path == 'yes'}
                        onChange={() => {
                            updateSettings({
                                ...allData,
                                use_relative_path: 'yes' == use_relative_path ? 'no' : 'yes'
                            })
                        }}
                    />
                    <p className="description">
                        {!hasFilter('wp_travel_settings_tab_invoice_fields_tooltip', 'wp_travel') &&
                            __('Use image path as var/www/html... instead of http to generate pdf invoice.', 'wp-travel-pro')
                        }
                    </p>
                </div>
            </PanelRow>

            <PanelRow>
                <label>{_wp_travel.setting_strings.invoice.invoice_logo}</label>
                <div id="wp-travel-invoice-logo" className="wp-travel-field-value">
                    <div className="media-preview">
                        {isFetchingImage && <Spinner />}
                        {imageUrl && <img src={imageUrl} height="100" width="50%" />}
                        <Button isPrimary onClick={() => mediaInstance.open()}>{imageUrl ? _wp_travel.setting_strings.invoice.change_image : _wp_travel.setting_strings.invoice.select_image}</Button>
                    </div>
                </div>
            </PanelRow>

            <PanelRow>
                <label>{_wp_travel.setting_strings.invoice.invoice_address}</label>
                <div id="wp-travel-invoice-address" className="wp-travel-field-value">
                    <TextControl
                        value={invoice_address}
                        onChange={
                            (value) => {
                                updateSettings({
                                    ...allData,
                                    invoice_address: value
                                })
                            }
                        }
                    />
                </div>
            </PanelRow>

            <PanelRow>
                <label>{_wp_travel.setting_strings.invoice.invoice_contact}</label>
                <div id="wp-travel-invoice-contact" className="wp-travel-field-value">
                    <TextControl
                        value={invoice_contact}
                        onChange={
                            (value) => {
                                updateSettings({
                                    ...allData,
                                    invoice_contact: value
                                })
                            }
                        }
                    />
                </div>
            </PanelRow>

            <PanelRow>
                <label>{_wp_travel.setting_strings.invoice.invoice_website}</label>
                <div id="wp-travel-invoice-website" className="wp-travel-field-value">
                    <TextControl
                        value={invoice_website}
                        onChange={
                            (value) => {
                                updateSettings({
                                    ...allData,
                                    invoice_website: value
                                })
                            }
                        }
                    />
                </div>
            </PanelRow>
        </>
    )
}
